import React from "react";

//UI Material
import { Box } from "@mui/material";

//React-chartjs-2
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartsJS,
  CategoryScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
} from "chart.js";

//Helpers
import { getFilteredTOrdersByDateRangeFromLocalTimeStrings } from "../../Helpers/orderFunctions";
import { evstations } from "../../Helpers/productSelector";

ChartsJS.register(
  CategoryScale,
  PointElement,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export default function StationsGraph({ data = [], year }) {
  const extractedInfo = getFilteredTOrdersByDateRangeFromLocalTimeStrings(
    data.filter((order) => evstations.includes(order.productName)),
    `1/1/${year}`,
    `12/31/${year}`,
    "finishedAt"
  );

  //Function to generate graph datasets
  const generateDataSets = () => {
    let products = [
      {
        label: "Estación Portátil",
        data: new Array(12).fill(0),
        backgroundColor: "#000000",
        borderColor: "#000000",
        pointRadius: 1,
        tension: 0.2,
      },
      {
        label: "Estación Portátil Plus",
        data: new Array(12).fill(0),
        backgroundColor: "#003C3C",
        borderColor: "#003C3C",
        pointRadius: 1,
        tension: 0.2,
      },
      {
        label: "Estación Pública",
        data: new Array(12).fill(0),
        backgroundColor: "#007878",
        borderColor: "#007878",
        pointRadius: 1,
        tension: 0.2,
      },
      {
        label: "Estación Tipo Wallbox",
        data: new Array(12).fill(0),
        backgroundColor: "#0074B4",
        borderColor: "#0074B4",
        pointRadius: 1,
        tension: 0.2,
      },
      {
        label: "Estación Tipo Wallbox Plus",
        data: new Array(12).fill(0),
        backgroundColor: "#00B4B4",
        borderColor: "#00B4B4",
        pointRadius: 1,
        tension: 0.2,
      },
      {
        label: "Estación Tipo Wallbox con pedestal",
        data: new Array(12).fill(0),
        backgroundColor: "#00c4B6",
        borderColor: "#00c4B6",
        pointRadius: 1,
        tension: 0.2,
      },
      {
        label: "Estación Tipo Wallbox con método de pago",
        data: new Array(12).fill(0),
        backgroundColor: "#00B5B9",
        borderColor: "#00B5B9",
        pointRadius: 1,
        tension: 0.2,
      },
      {
        label: "Estación Tipo Wallbox doble",
        data: new Array(12).fill(0),
        backgroundColor: "#00B4B4",
        borderColor: "#00B4B4",
        pointRadius: 1,
        tension: 0.2,
      },
    ];

    //Fill order objects iterating trough orders
    for (const { productsStatus, productName } of extractedInfo) {
      for (const product of productsStatus) {
        try {
          const month = new Date(product.finishedAt).getMonth();
          //Validate month
          if (!isNaN(Number(month))) {
            const targetOrder = products.find(
              (product) => product.label === productName
            );

            targetOrder.data[month] += 1;
          }
        } catch (e) {
          console.log(e);
        }
      }
    }

    return products;
  };

  //Function to generate chart data
  const generateChartData = () => ({
    datasets: generateDataSets(),
    labels: [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Set",
      "Oct",
      "Nov",
      "Dic",
    ],
  });
  //Function to generate chart options
  const generateChartOptions = () => ({
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: { beginAtZero: true },
    },
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 15,
        },
      },
      title: {
        display: true,
        text: `Estaciones de carga producidas (Finalizadas) para cada mes del año`,
      },
    },
  });

  // ==========>Component<==========
  return (
    <Box sx={{ minHeight: "250px" }}>
      <Bar options={generateChartOptions()} data={generateChartData()} />
    </Box>
  );
}
